import { render, staticRenderFns } from "./down_major.vue?vue&type=template&id=3a2bc3a9&"
import script from "./down_major.vue?vue&type=script&lang=js&"
export * from "./down_major.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports